import roadmapSprite from '@/assets/sprite/roadmap-sprite.svg';
import { Grid, Stack } from '@mui/material';
import { GameResultCellProps } from '..';

type Prop = {
    point: number;
};
const DiceIcon = (prop: Prop) => {
    const { point } = prop;

    return (
        <svg viewBox="0 0 24 24" overflow={'visible'}>
            <use
                xlinkHref={`${roadmapSprite}#fishprawncrab__dice__die-${point}`}
                width={'100%'}
                height={'100%'}
            />
        </svg>
    );
};
export const FishPrawnCrabGameResult = (props: GameResultCellProps) => {
    const { summary } = props;

    const dices: number[] = summary.Result.split(',').map(str => Number(str));
    return (
        <Stack className="item-fpc-game-result-container">
            {dices.map((d, idx) => {
                return (
                    <Grid
                        key={`fpc-dice-${idx}`}
                        container
                        className="dice-container"
                    >
                        <DiceIcon point={d} />
                    </Grid>
                );
            })}
        </Stack>
    );
};
